module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjYiIGhlaWdodD0iNjYiIHZpZXdCb3g9IjAgMCA2NiA2NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMS41IiB5PSIxLjUiIHdpZHRoPSI2Mi41MzM5IiBoZWlnaHQ9IjYyLjUzMzkiIHJ4PSI4LjUiIHN0cm9rZT0iIzAwRTg0RiIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxyZWN0IHg9IjU0LjkwNjciIHk9IjI4LjMzODkiIHdpZHRoPSI4Ljg1NTkzIiBoZWlnaHQ9IjQ0LjI3OTciIHJ4PSI0LjQyNzk3IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA1NC45MDY3IDI4LjMzODkpIiBmaWxsPSIjMDBFODRGIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/cart_minus.svg
// module id = +YYU
// module chunks = 1